import styled from 'styled-components'

export const EntityNameTextStyled = styled.span`
  font-weight: 600;
`
